import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  
  static values = {
    serviceRequestId: String,
    serviceRequestAgentUserId: String,
    serviceRequestStatus: String
  }
  
  static targets = ["confirmJoinCheckbox"]
  
  connect() {
    this.element.addEventListener("turbo:morph-element", (event) => {
      if (event.target === this.element) {
        this.serviceRequestIdValueChanged()
      }    
    })
  }
  
  confirmJoinCheckboxChanged() {
    if (this.hasConfirmJoinCheckboxTarget) {
      if (this.confirmJoinCheckboxTarget.checked) {
        this.enableButtons()
      } else {
        this.disableButtons()
      }
    }
  }
  
  disableButtons() {
    document.getElementById(`sidebar_decline_button_service_request_${this.serviceRequestIdValue}`)?.classList.add("disabled")
    document.getElementById(`sidebar_call_button_service_request_${this.serviceRequestIdValue}`)?.classList.add("disabled")
    document.getElementById(`zoom_launch_meeting_button_service_request_${this.serviceRequestIdValue}`)?.classList.add("disabled")
    document.getElementById(`zoom_decline_button_service_request_${this.serviceRequestIdValue}`)?.classList.add("disabled")
  }

  enableButtons() {
    document.getElementById(`sidebar_decline_button_service_request_${this.serviceRequestIdValue}`)?.classList.remove("disabled")
    document.getElementById(`sidebar_call_button_service_request_${this.serviceRequestIdValue}`)?.classList.remove("disabled")
    document.getElementById(`zoom_launch_meeting_button_service_request_${this.serviceRequestIdValue}`)?.classList.remove("disabled")
    document.getElementById(`zoom_decline_button_service_request_${this.serviceRequestIdValue}`)?.classList.remove("disabled")
  }

  serviceRequestIdValueChanged() {
    if (
      (this.serviceRequestStatusValue === "in_progress" || this.serviceRequestStatusValue === "waiting_for_answer") &&
      (this.serviceRequestAgentUserIdValue != document.body.dataset.currentUserId)
    ) {
        this.showActiveSessionWarning()
        document.addEventListener("turbo:render", () => this.showActiveSessionWarning(), { once: true })
    }      
  }
  
  showActiveSessionWarning() {
    this.element.classList.remove("hidden")
    this.disableButtons()
  }
  
}
